import {
  TOUR_DIALOG_Z_INDEX,
  TOUR_MENU_Z_INDEX,
  TOUR_NESTED_DIALOG_Z_INDEX,
} from './AnchoredTourGuide';
import { isOnboardingFormTourActive } from './onboardingFormTourState';

const isTourStackingActive = (taskId?: string) => isOnboardingFormTourActive(taskId);

/** MUI menu/modal stacking overrides — only while the given form tour task is active. */
export const getTourMenuSx = (taskId?: string) =>
  isTourStackingActive(taskId) ? { zIndex: TOUR_MENU_Z_INDEX } : undefined;

export const getTourMenuSlotProps = (taskId?: string) => {
  if (!isTourStackingActive(taskId)) {
    return undefined;
  }

  return { sx: { zIndex: TOUR_MENU_Z_INDEX } };
};

export const getTourSelectMenuProps = (taskId?: string) => {
  if (!isTourStackingActive(taskId)) {
    return undefined;
  }

  return {
    sx: { zIndex: TOUR_MENU_Z_INDEX },
    slotProps: {
      paper: { sx: { zIndex: TOUR_MENU_Z_INDEX } },
    },
  };
};

export const getTourAutocompleteSlotProps = (taskId?: string) => {
  if (!isTourStackingActive(taskId)) {
    return undefined;
  }

  return {
    popper: { sx: { zIndex: TOUR_MENU_Z_INDEX } },
    paper: { sx: { zIndex: TOUR_MENU_Z_INDEX } },
  };
};

/** Popover surfaces the user must interact with during a tour step (above the guide panel). */
export const getTourPopoverSlotProps = (taskId?: string) => {
  if (!isTourStackingActive(taskId)) {
    return {};
  }

  return {
    root: { sx: { zIndex: TOUR_MENU_Z_INDEX } },
    paper: { sx: { zIndex: TOUR_MENU_Z_INDEX } },
  };
};

/** Primary tour dialog (below guide panel so steps stay visible in front). */
export const getTourDialogStackingProps = (taskId?: string) => {
  if (!isTourStackingActive(taskId)) {
    return {};
  }

  return {
    sx: { zIndex: TOUR_DIALOG_Z_INDEX },
    slotProps: { root: { sx: { zIndex: TOUR_DIALOG_Z_INDEX } } },
  };
};

/** Dialog opened above another tour dialog, still below the guide panel. */
export const getTourNestedDialogStackingProps = (taskId?: string) => {
  if (!isTourStackingActive(taskId)) {
    return {};
  }

  return {
    sx: { zIndex: TOUR_NESTED_DIALOG_Z_INDEX },
    slotProps: { root: { sx: { zIndex: TOUR_NESTED_DIALOG_Z_INDEX } } },
  };
};
